import { AddProductToSavedBasket, EditProductsInSavedBasket } from "../../../Services/BasketService"
import { useAuth } from "../../../Providers/AuthProvider"
import { toast } from "react-toastify"
import { useConfig } from "../../../Providers/ConfigProvider"

const useAddProductsToSavedBasket = () => {
    const { authState } = useAuth()
    const { api } = useConfig()

    const handleAddProductsToSavedBasket = async (basketId, products, showToast) => {
        try {
            var res = await AddProductToSavedBasket(api, basketId, products)
            if (showToast) {
                toast.success('Dodano pozycje do szybkokoszyka')
            }
            return true
        } catch (error) {
            toast.error('Błąd w trakcie dodawania pozycji do szybkokoszyka')
            return false
        }
    }

    /**
     * DK : Funkcja do edycji zapisanego koszyka
     * @param {*} basketId 
     * @param {*} products 
     * @returns zedytowany szybkokoszyk
     */
    const handleEditProductsInSavedBasket = async (basketId, products) => {
        try {
            var data = products.map(p => ({
                BasketId: basketId,
                Index: p.artNo,
                Qty: p.qty,
            }))
            const res = await EditProductsInSavedBasket(api, data, authState.custId, authState.siteId, authState.whId)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    return {
        handleAddProductsToSavedBasket,
        handleEditProductsInSavedBasket,
    }
}

export default useAddProductsToSavedBasket